import { render, staticRenderFns } from "./batchCreateSettlementDialog.vue?vue&type=template&id=6240140d&scoped=true"
import script from "./batchCreateSettlementDialog.vue?vue&type=script&lang=js"
export * from "./batchCreateSettlementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240140d",
  null
  
)

export default component.exports